// --- 结算中心 --- //

export default [
  {
    name: 'accountFinance',
    path: '/carWashSuperviseSystem/:carWashId/settlementCenter/accountFinance',
    meta: { title: '账户资金' },
    component: require('business/carWashSuperviseSystem/settlementCenter/accountFinance/list.vue').default
  },
  {
    name: 'withdraw',
    path: '/carWashSuperviseSystem/:carWashId/settlementCenter/withdraw',
    meta: { title: '提现' },
    component: require('business/carWashSuperviseSystem/settlementCenter/accountFinance/withdraw.vue').default
  },
  {
    name: 'withdrawDetail',
    path: '/carWashSuperviseSystem/:carWashId/settlementCenter/withdrawDetail',
    meta: { title: '提现明细' },
    component: require('business/carWashSuperviseSystem/settlementCenter/accountFinance/detail.vue').default
  },
  {
    name: 'bankCardManagement',
    path: '/carWashSuperviseSystem/:carWashId/settlementCenter/bankCardManagement',
    meta: { title: '银行卡管理' },
    component: require('business/carWashSuperviseSystem/settlementCenter/bankCardManagement/list.vue').default
  }
]
